module.exports = __webpack_public_path__ + "img/partner6.b031a35c.png";